// funciones complementarias de GxPrint.
// eslint-disable-next-line no-unused-vars
import * as FxLog from './FxLog';
import * as FxFetch from './FxFetch';
import * as FxInet from './FxInet';
import * as FxDat from './FxDat';
import { getStoreValue } from "../gx/GxStore";

export const isAccepted = async (inClient) => {
  let record = {};
  record['table'] = 'i_user_license';
  record['field'] = 'dtAccepted';
  record['where'] = `inUser='${getStoreValue('StoreSession', 'inUser')}'`;
  return Promise.all([FxFetch.doJsonX("general/r", record)]).then((result) => {
    if (result[0]) {
      FxLog.infox('FxLicenseAgreement.isAccepted', '...result[0]:', result[0]);
      return result[0].theValue;
    }
  });
};

export const getLicenseAgreementText = async () => {
  return fetch('/html/license_agreement_en.htm')
    .then(response => {
      // 1. Verificamos si la solicitud fue exitosa (código de estado 200 OK, etc.).
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      // 2. ¡Aquí está la clave! Usamos .text() para leer el contenido del cuerpo de la respuesta como una cadena de texto plana.
      return response.text();
    })
    .then(data => {
      // 3. 'data' ahora contiene el texto completo del archivo HTML.
      return data;
    })
    .catch(error => {
      // Manejo de errores si la solicitud falla o hay un problema al leer el archivo.
      return error;
    });
}

export const saveAccepted = () => {
  Promise.all([FxInet.getIP()]).then((result) => {
    let ip = result[0]||'';

    Promise.all([getLicenseAgreementText()]).then((result) => {
      let htmlString = result[0];
      let licenseAgreementText = convertHtmlToPlainText(extractBodyContent(htmlString));

      let filter = {};
      let record = {};
      filter['table'] = 'i_user_license';
      record['inUser'] = getStoreValue('StoreSession', 'inUser');
      record['dtAccepted'] = FxDat.timestamp();
      record['txIpAddress'] = ip;
      record['txUserAgent'] = navigator.userAgent;
      record['txUserLicense'] = licenseAgreementText;
    
      Promise.all([FxFetch.doJsonF('general/cu', filter, record)]).then((result) => {
        FxLog.infox('FxLicenseAgreement.saveAccepted', '...result[0]:', result[0]);
        if (result[0].theValue === 'OK') {
        }
      });
    });
  });
}

// Función para extraer solo el contenido del body (HTML)
function extractBodyContent(htmlString) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');
  const bodyElement = doc.body;
  return bodyElement ? bodyElement.innerHTML : '';
}

// Función que convierte HTML a texto plano (la que ya teníamos)
function convertHtmlToPlainText(htmlString) {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = htmlString;
  return tempDiv.textContent || tempDiv.innerText || '';
}
